import { assertUnreachable } from 'src/lib/assertUnreachable';
import { Config } from 'src/lib/config/config';
import { ErrorInsightsListGroupByColumn } from 'src/lib/graphqlTypes/types';

import { BreakdownOption, GroupOption } from './sharedTypes';

export function getRouteParamForGroupOption(groupOption: GroupOption) {
  switch (groupOption) {
    case ErrorInsightsListGroupByColumn.SERVICE:
      return Config.queryParameters.ErrorsServiceFilter;
    case ErrorInsightsListGroupByColumn.CODE:
      return Config.queryParameters.ErrorsCodeFilter;
    case ErrorInsightsListGroupByColumn.CLIENT_NAME:
      return Config.queryParameters.ErrorsClientNameFilter;
    default:
      assertUnreachable(groupOption);
  }
}

export function getRouteParamForBreakdownOption(
  breakdownOption: BreakdownOption,
) {
  switch (breakdownOption) {
    case ErrorInsightsListGroupByColumn.SERVICE:
      return Config.queryParameters.ErrorsServiceFilter;
    case ErrorInsightsListGroupByColumn.CODE:
      return Config.queryParameters.ErrorsCodeFilter;
    case ErrorInsightsListGroupByColumn.PATH:
      return Config.queryParameters.ErrorsPathFilter;
    default:
      assertUnreachable(breakdownOption);
  }
}
